const inputFields = [
  {
    name: "name",
    type: "text",
    label: "Name",
  },
  {
    name: "language",
    type: "dynamic_select",
    label: "Select Language",
    placeholder: "",
    options: [],
  },
];

export default inputFields;
